import * as React from 'react';
import Svg, {Rect, G, Path, Defs, ClipPath} from 'react-native-svg';
import {backgroundColor} from 'src/components/img/svg/rewards/PayEarnPoints';
import Styles from 'src/components/Styles';

interface IRewardSquareIconProps {
  color?: string;
}

function RewardSquareIcon(props: IRewardSquareIconProps) {
  return (
    <Svg width={51} height={50} viewBox="0 0 51 50" fill="none">
      <Rect
        x={0.5}
        width={50}
        height={50}
        rx={8}
        fill={
          backgroundColor(props.color ?? Styles.Colors.PayNew.primary01).color
        }
        fillOpacity={
          backgroundColor(props.color ?? Styles.Colors.PayNew.primary01).opacity
        }
      />
      <G clipPath="url(#clip0_25290_45523)">
        <Path
          d="M23.932 13.428A4.935 4.935 0 0019.682 11h-.12a4.813 4.813 0 00-4.287 7h-1.4a2.626 2.626 0 00-2.625 2.625v3.5c0 1.143.733 2.116 1.75 2.477V35.5c0 1.93 1.57 3.5 3.5 3.5H34c1.93 0 3.5-1.57 3.5-3.5v-8.898a2.632 2.632 0 001.75-2.477v-3.5A2.626 2.626 0 0036.625 18h-1.4a4.813 4.813 0 00-4.288-7h-.12a4.935 4.935 0 00-4.249 2.428l-1.318 2.248-1.318-2.242v-.006zm12.693 7.197v3.5H27v-3.5h9.625zm-13.125 0v3.5h-9.625v-3.5H23.5zm0 6.125v9.625h-7a.878.878 0 01-.875-.875v-8.75H23.5zm3.5 9.625V26.75h7.875v8.75a.878.878 0 01-.875.875h-7zM30.938 18h-4.009l1.903-3.238a2.305 2.305 0 011.985-1.137h.12a2.187 2.187 0 110 4.375zM23.5 18h-3.938a2.187 2.187 0 110-4.375h.12c.816 0 1.576.432 1.986 1.137L23.571 18H23.5z"
          fill={props.color ?? Styles.Colors.PayNew.primary01}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_25290_45523">
          <Path
            fill={Styles.white}
            transform="translate(11.25 11)"
            d="M0 0H28V28H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default RewardSquareIcon;
